import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
// import TextField from '@material-ui/core/TextField';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
// import LogoImage from "../assets/logo2.png";
import LogoImage from '../assets/aparticon.png'
import LoginBg from "../assets/pattern.png";
import { makeStyles } from "@material-ui/core/styles";

import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import clsx from "clsx";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import http from "../services/httpService";
import { useHistory } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import RecoverPassword from "./recoverPassword";
// import { otpPath } from '../utils/varialbles';
import Otp from "./otp";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  loginbgimg: {
    backgroundImage: `url(${LoginBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  textField: {
    margin: "10px auto",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "350px",
    margin: "auto",
    marginTop: theme.spacing(1),
  },
  submit: {
    borderRadius: "8px",
  },
}));

function Login() {
  localStorage.clear();
  const classes = useStyles();
  const history = useHistory();
  const [showRecoverPassword, setShowRecoverPassword] = useState(false)
  const [values, setValues] = React.useState({
    password: "",
    email: "",
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // event.stopImmediatePropagation();
    let postObject = {
      email: values["email"],
      password: values["password"],
    };
    http
      .post("/login", postObject)
      .then(function (response) {
        response = response.data;
        if (
          response &&
          response.statusCode === 0 &&
          response.token &&
          response.Employee_ID
        ) {
          localStorage.setItem("token", response.token);
          localStorage.setItem("empName", response["Employee Name"]);
          localStorage.setItem("employee_id", response.Employee_ID);
          toast.success("Logged in Successfully");
          history.push("/dashboard");
        } else {
          toast.error(response.data);
          // alert(response.data)
        }
      })
      .catch(function (error) { });
  };

  const [showotp, setShowOtp] = useState(false);

  const goToOtp = () => {
    setShowOtp(true);
  };
  const updateLoginPage = () => {
    setShowRecoverPassword(!showRecoverPassword)
  }

  return (
    <Grid container component="main" className={(classes.root, "loginroot")}>
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      <CssBaseline />
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        className={(classes.loginbgimg, "loginbgimg")}
      >
        <div className="loginbgmidimg"></div>
        <div className="getworking">Get Working!</div>
      </Grid>

      <Grid item xs={12} sm={12} md={6} component={Paper} elevation={6} square>
        <div className={(classes.paper, "loginpaper")}>
          <div>
            <img src={LogoImage} alt="Savart Logo" className="savartlogo" />

          </div>

          <form className={(classes.form, "loginform")} noValidate>
            {
              showRecoverPassword ?
                (
                  <>
                    <RecoverPassword
                      login={updateLoginPage}

                    />
                  </>
                ) : (
                  <>

                    {showotp ? (
                      ''
                    ) : (
                      <>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                        >
                          <InputLabel htmlFor="email">Email</InputLabel>
                          <Input
                            id="email"
                            variant="outlined"
                            margin="none"
                            required
                            fullWidth
                            type="text"
                            value={values.email}
                            onChange={handleChange("email")}
                          />
                        </FormControl>
                        <FormControl
                          fullWidth
                          className={clsx(classes.margin, classes.textField)}
                        >
                          <InputLabel htmlFor="standard-adornment-password">
                            Password
                          </InputLabel>
                          <Input
                            id="standard-adornment-password"
                            variant="outlined"
                            margin="none"
                            required
                            fullWidth
                            type={values.showPassword ? "text" : "password"}
                            value={values.password}
                            onChange={handleChange("password")}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {values.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>

                        <div
                          className="login_text"
                        >
                          <div item xs={6} sm={6}
                            style={{ color: "#0066FF", cursor: "pointer" }}
                          >
                            <span
                              onClick={updateLoginPage}
                            >
                              Forgot Password?
                            </span>
                          </div>
                          <div item xs={6} sm={6}>
                            <Button
                              type="button" // Need to change type to submit later
                              fullWidth
                              variant="contained"
                              color="primary"
                              className={classes.submit}
                              onClick={handleSubmit}
                            >
                              Login
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                  </>

                )}

          </form>
        </div>
      </Grid>
    </Grid>
  );
}

export default Login;
